import React from "react";
import { Lock, Cookie, Eye, Database, Trash2 } from "lucide-react";
import SEO from "../../components/SEO";
import { useLanguage } from "../../context/LanguageContext";

export default function Privacy() {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen bg-spiritual-white dark:bg-gray-950 text-gray-800 dark:text-gray-100 font-body py-20 px-6">
            <SEO 
              title={t("privacy_title")} 
              description={t("privacy_short_desc")} 
              url="/privacy" 
            />
            <main className="max-w-4xl mx-auto space-y-12">

                {/* HEADER */}
                <div className="text-center space-y-4">
                    <h1 className="text-4xl font-display font-bold">{t("privacy_title")}</h1>
                    <p className="text-gray-500">{t("privacy_tagline")}</p>
                </div>

                {/* SUMMARY BOX */}
                <div className="bg-brand-blue/5 border border-brand-blue/20 p-6 rounded-xl">
                    <h3 className="text-lg font-bold text-brand-blue mb-2">{t("privacy_short_title")}</h3>
                    <p className="text-gray-700 dark:text-gray-300">
                        {t("privacy_short_desc")}
                    </p>
                </div>

                {/* 1. DATA WE COLLECT */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold flex items-center gap-2">
                        <Database className="w-6 h-6 text-brand-blue" />
                        {t("privacy_sec1_title")}
                    </h2>
                    <div className="space-y-3 text-gray-600 dark:text-gray-300">
                        <p><strong>{t("privacy_sec1_acc")}</strong> {t("privacy_sec1_acc_desc")}</p>
                        <p><strong>{t("privacy_sec1_chat")}</strong> {t("privacy_sec1_chat_desc")}</p>
                        <p><strong>{t("privacy_sec1_usage")}</strong> {t("privacy_sec1_usage_desc")}</p>
                    </div>
                </section>

                {/* 2. HOW WE USE DATA */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold flex items-center gap-2">
                        <Eye className="w-6 h-6 text-brand-blue" />
                        {t("privacy_sec2_title")}
                    </h2>
                    <ul className="list-disc pl-5 space-y-2 text-gray-600 dark:text-gray-300">
                        <li>{t("privacy_sec2_li1")}</li>
                        <li>{t("privacy_sec2_li2")}</li>
                        <li>{t("privacy_sec2_li3")}</li>
                        <li><strong>{t("privacy_sec2_li4")}</strong></li>
                    </ul>
                </section>

                {/* 3. COOKIE POLICY */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold flex items-center gap-2">
                        <Cookie className="w-6 h-6 text-brand-blue" />
                        {t("privacy_sec3_title")}
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300">
                        {t("privacy_sec3_intro")}
                    </p>
                    <div className="grid md:grid-cols-2 gap-4">
                        <div className="p-4 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-lg">
                            <span className="font-bold block mb-1">{t("privacy_sec3_auth_title")}</span>
                            <span className="text-sm text-gray-500">{t("privacy_sec3_auth_desc")}</span>
                        </div>
                        <div className="p-4 bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-lg">
                            <span className="font-bold block mb-1">{t("privacy_sec3_pref_title")}</span>
                            <span className="text-sm text-gray-500">{t("privacy_sec3_pref_desc")}</span>
                        </div>
                    </div>
                    <p className="text-sm text-gray-500 mt-2 italic">
                        {t("privacy_sec3_tracking")}
                    </p>
                </section>

                {/* 4. DATA SECURITY */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold flex items-center gap-2">
                        <Lock className="w-6 h-6 text-brand-blue" />
                        {t("privacy_sec4_title")}
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300">
                        {t("privacy_sec4_desc1")}
                        <br />
                        {t("privacy_sec4_desc2")}
                    </p>
                </section>

                {/* 5. DATA DELETION */}
                <section className="space-y-4">
                    <h2 className="text-2xl font-bold flex items-center gap-2">
                        <Trash2 className="w-6 h-6 text-red-500" />
                        {t("privacy_sec5_title")}
                    </h2>
                    <p className="text-gray-600 dark:text-gray-300">
                        {t("privacy_sec5_desc")}
                    </p>
                </section>

            </main>
        </div>
    );
}
